import { BaseResponse, request } from '../request';

import {
  BotsListResponse,
  BotInfo,
  BotBaseInfo,
  BotWorkflow,
  BotExample,
  PurchaseBotResponse,
  CustomService,
  CustomServiceResponse,
} from './types';

/**
 * 获取所有智能体列表
 * @param 
 * @returns 
 */
export async function getBots(params: any): Promise<BaseResponse<BotsListResponse>> {
  return await request(`/openapi/v1/bots`, {
    method: 'get',
    params
  });
}

/**
 * 获取推荐智能体列表
 * @param 
 * @returns 
 */
export async function getTopBots(): Promise<BaseResponse<BotsListResponse>> {
  return await request(`/openapi/v1/bots/top`, {
    method: 'get'
  });
}

/**
 * 获取智能体信息
 * @param botId 智能体ID
 * @returns
 **/
export async function getBotInfo(botId: string): Promise<BaseResponse<BotInfo>> {
  return await request(`/openapi/v1/bots/${botId}`, {
    method: 'get'
  });
}

/**
 * 获取我的智能体列表
 * @returns 
 */
export async function getMyBots(params: any): Promise<BaseResponse<BotsListResponse>> {
  return await request(`/openapi/v1/bots/me`, {
    method: 'get',
    params
  });
}

/**
 * 创建/编辑智能体
 * @param data 智能体基本信息
 * @returns {Promise<BaseResponse>}
 */
export async function createMyBot(data: BotBaseInfo): Promise<BaseResponse> {
  return await request(`/openapi/v1/bots`, {
    method: 'post',
    data
  });
}

/**
 * 删除智能体
 * @param botId 智能体ID
 * @returns {Promise<BaseResponse>}
 */
export async function deleteBot(botId: string): Promise<BaseResponse> {
  return await request(`/openapi/v1/bots/${botId}`, {
    method: 'delete'
  });
};

/**
 * 创建/编辑智能体工作流
 * @param data 智能体工作流数组
 * @returns {Promise<BaseResponse>}
 */
export async function createMyBotWorkflows(botId: string, data: BotWorkflow[]): Promise<BaseResponse> {
  return await request(`/openapi/v1/bots/${botId}/workflows`, {
    method: 'post',
    data: {
      workflows: data
    }
  });
}

/**
 * 删除智能体
 * @param botId 智能体ID
 * @returns {Promise<BaseResponse>}
 */
export async function deleteWorkflow(botId: string, workflowId:string): Promise<BaseResponse> {
  return await request(`/openapi/v1/bots/${botId}/workflows/${workflowId}`, {
    method: 'delete'
  });
};

/**
 * 创建智能体案例
 * @param botId 
 * @param data 
 * @returns 
 */
export async function addMyBotExample(botId: string, data: {examples: BotExample[]}): Promise<BaseResponse> {
  return await request(`/openapi/v1/bots/${botId}/examples`, {
    method: 'post',
    data
  });
}

/**
 * 删除智能体案例
 * @param botId 智能体ID
 * @returns {Promise<BaseResponse>}
 */
export async function deleteExample(botId: string, exampleId:string): Promise<BaseResponse> {
  return await request(`/openapi/v1/bots/${botId}/examples/${exampleId}`, {
    method: 'delete'
  });
};

/**
 * 获取已购买的智能体
 * @returns 
 */
export async function getPurchasedBots(): Promise<BaseResponse<PurchaseBotResponse>> {
  return await request(`/openapi/v1/bots/purchased`, {
    method: 'get'
  });
}

export async function getCustomServices(): Promise<BaseResponse<CustomServiceResponse>> {
  return await request(`/openapi/v1/bots/custom`, {
    method: 'get'
  });
}

export async function fetchCustomServices(values: CustomService): Promise<BaseResponse> {
  return await request(`/openapi/v1/bots/custom`, {
    method: 'post',
    data: values
  });
}
